import React from 'react';
import ReactDOM from 'react-dom';
import CalculatorInput from 'CalculatorInput';
import { Desktop, LargeMobile } from 'Responsive';
import { formatNumber } from 'Utils';

export default class RetirementCalculator extends React.Component {
  static init(id, props) {
    ReactDOM.render(
      <RetirementCalculator {...props} />,
      document.getElementById(id),
    );
  }

  static renderDetails() {
    return (
      <div>
        <h2>Retirement Calculator</h2>
        <h4>Methodology</h4>
        <p>
          Our team at FormSwift created a retirement calculator to help you
          determine how much you will have saved and what your investment
          return will be. To use the calculator, insert the following inputs:
          current age, age of retirement, amount of money currently saved for
          retirement, annual retirement deposit, annual withdrawal amount from
          retirement savings (may or may not be applicable depending on
          age/situation), percent inflation, and percent investment return.
        </p>
      </div>
    );
  }


  constructor() {
    super();
    this.state = {
      age: '',
      retirementAge: '',
      amountSaved: '',
      annualDeposit: '',
      inflationPercent: '3',
      investmentPercent: '6.5',
      retirementResult: '0',
      investmentResult: '0',
    };
    this.calculateResults = this.calculateResults.bind(this);
  }

  calculateResults() {
    let amountSaved = +this.state.amountSaved;
    let curAge = +this.state.age;
    let previousYearReturn = 0;
    let totalInvestmentReturn = 0;

    while (curAge <= +this.state.retirementAge) {
      amountSaved += previousYearReturn;
      const investmentReturn = amountSaved * (+this.state.investmentPercent / 100);
      const inflationDeduction = amountSaved * (+this.state.inflationPercent / 100);
      const investmentWithInflation = (investmentReturn - inflationDeduction);
      previousYearReturn = investmentWithInflation + +this.state.annualDeposit;
      totalInvestmentReturn += investmentWithInflation;
      curAge += 1;
    }

    this.setState({
      retirementResult: formatNumber(amountSaved.toFixed(2)),
      investmentResult: formatNumber(totalInvestmentReturn.toFixed(2)),
    });
  }

  render() {
    return (
      <div className="container retirement-calculator-container">
        <div className="row">
          <div className="col-xs-12 col-md-2 col-md-offset-1">
            <LargeMobile>
              {RetirementCalculator.renderDetails()}
            </LargeMobile>
            <CalculatorInput
              title="AGE"
              value={this.state.age}
              onChange={age => this.setState({ age })}
            />
            <CalculatorInput
              title="RETIREMENT AGE"
              value={this.state.retirementAge}
              onChange={retirementAge => this.setState({ retirementAge })}
            />
            <span className="divider" />
            <CalculatorInput
              title="AMOUNT CURRENTLY SAVED FOR RETIREMENT"
              value={this.state.amountSaved}
              onChange={amountSaved => this.setState({ amountSaved })}
              type="monetary"
            />
            <CalculatorInput
              title="ANNUAL RETIREMENT DEPOSIT"
              value={this.state.annualDeposit}
              onChange={annualDeposit => this.setState({ annualDeposit })}
              type="monetary"
            />
            <span className="divider" />
            <CalculatorInput
              title="INFLATION (%)"
              value={this.state.inflationPercent}
              onChange={inflationPercent => this.setState({ inflationPercent })}
              type="percent"
            />
            <CalculatorInput
              title="INVESTMENT RETURN (%)"
              value={this.state.investmentPercent}
              onChange={investmentPercent => this.setState({ investmentPercent })}
              type="percent"
            />
            <span className="divider" />
            <button onClick={this.calculateResults}> Calculate </button>
          </div>
          <div className="col-xs-12 col-md-7 col-md-offset-1">
            <Desktop>
              {RetirementCalculator.renderDetails()}
            </Desktop>
            <div className="retirement-calculator-results">
              <p>AMOUNT YOU WILL HAVE IN RETIREMENT</p>
              <span>{this.state.retirementResult}</span>
            </div>
            <div className="retirement-calculator-results">
              <p>AMOUNT OF INVESTMENT RETURN</p>
              <span>{this.state.investmentResult}</span>
            </div>
            <p className="retirement-calculator-link">
              Source: <a href="https://www.retirementsimulation.com/simple/">https://www.retirementsimulation.com/simple/</a>
            </p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src-react/RetirementCalculator/index.jsx